<div style="text-align:center;padding-top:10px" *ngIf="visionScreenings.length == 0  && isBusy==false" translate>
    No Vision data exists for student
</div>
<div *ngIf="visionScreenings.length > 0 ">
    <mat-table [dataSource]="angularMatData" matSort matSortDisableClear matSortActive="Date" matSortDirection="desc"
        style="display: grid">
        <ng-container matColumnDef="Date">
            <mat-header-cell *matHeaderCellDef mat-sort-header style="min-width: 120px;">Date
                <filter class="mat-filter" [data]="angularMatData" columnName="Date" dataType="date"></filter>
            </mat-header-cell>
            <mat-cell *matCellDef="let row" style="min-width: 120px;">
                <span *ngIf="row.Date != null && row.Date != '0001-01-01T00:00:00'">
                    {{row.Date|date:'MM/dd/yyyy'}}
                </span>
            </mat-cell>
        </ng-container>
        <ng-container matColumnDef="VisionTest">
            <mat-header-cell *matHeaderCellDef mat-sort-header style="min-width: 120px;">Vision Test
                <filter class="mat-filter" [data]="angularMatData" columnName="VisionTest" dataType="string">
                </filter>
            </mat-header-cell>
            <mat-cell *matCellDef="let row" style="min-width: 120px;">{{row.VisionTest}}</mat-cell>
        </ng-container>
        <ng-container matColumnDef="BinocularNear">
            <mat-header-cell *matHeaderCellDef mat-sort-header style="min-width: 140px;">Binocular Near
                <filter class="mat-filter" [data]="angularMatData" columnName="BinocularNear" dataType="string">
                </filter>
            </mat-header-cell>
            <mat-cell *matCellDef="let row" style="min-width: 140px;">{{row.BinocularNear}}</mat-cell>
        </ng-container>
        <ng-container matColumnDef="BinocularFar">
            <mat-header-cell *matHeaderCellDef mat-sort-header style="min-width: 140px;">Binocular Far
                <filter class="mat-filter" [data]="angularMatData" columnName="BinocularFar" dataType="string">
                </filter>
            </mat-header-cell>
            <mat-cell *matCellDef="let row" style="min-width: 140px;">{{row.BinocularFar}}</mat-cell>
        </ng-container>
        <ng-container matColumnDef="AcuityFarRight">
            <mat-header-cell *matHeaderCellDef mat-sort-header style="min-width: 160px;">Acuity Far Right
                <filter class="mat-filter" [data]="angularMatData" columnName="AcuityFarRight" dataType="string">
                </filter>
            </mat-header-cell>
            <mat-cell *matCellDef="let row" style="min-width: 160px;">{{row.AcuityFarRight}}</mat-cell>
        </ng-container>
        <ng-container matColumnDef="AcuityFarLeft">
            <mat-header-cell *matHeaderCellDef mat-sort-header style="min-width: 160px;">Acuity Far Left
                <filter class="mat-filter" [data]="angularMatData" columnName="AcuityFarLeft" dataType="string">
                </filter>
            </mat-header-cell>
            <mat-cell *matCellDef="let row" style="min-width: 160px;">{{row.AcuityFarLeft}}</mat-cell>
        </ng-container>
        <ng-container matColumnDef="AcuityNearRight">
            <mat-header-cell *matHeaderCellDef mat-sort-header style="min-width: 160px;">Acuity Near Right
                <filter class="mat-filter" [data]="angularMatData" columnName="AcuityNearRight" dataType="string">
                </filter>
            </mat-header-cell>
            <mat-cell *matCellDef="let row" style="min-width: 160px;">{{row.AcuityNearRight}}</mat-cell>
        </ng-container>
        <ng-container matColumnDef="AcuityNearLeft">
            <mat-header-cell *matHeaderCellDef mat-sort-header style="min-width: 160px;">Acuity Near Left
                <filter class="mat-filter" [data]="angularMatData" columnName="AcuityNearLeft" dataType="string">
                </filter>
            </mat-header-cell>
            <mat-cell *matCellDef="let row" style="min-width: 160px;">{{row.AcuityNearLeft}}</mat-cell>
        </ng-container>
        <ng-container matColumnDef="MuscularNear">
            <mat-header-cell *matHeaderCellDef mat-sort-header style="min-width: 140px;">Muscular Near
                <filter class="mat-filter" [data]="angularMatData" columnName="MuscularNear" dataType="string">
                </filter>
            </mat-header-cell>
            <mat-cell *matCellDef="let row" style="min-width: 140px;">{{row.MuscularNear}}</mat-cell>
        </ng-container>
        <ng-container matColumnDef="MuscularFar">
            <mat-header-cell *matHeaderCellDef mat-sort-header style="min-width: 140px;">Muscular Far
                <filter class="mat-filter" [data]="angularMatData" columnName="MuscularFar" dataType="string">
                </filter>
            </mat-header-cell>
            <mat-cell *matCellDef="let row" style="min-width: 140px;">{{row.MuscularFar}}</mat-cell>
        </ng-container>
        <ng-container matColumnDef="ColorVision">
            <mat-header-cell *matHeaderCellDef mat-sort-header style="min-width: 140px;">Color Vision
                <filter class="mat-filter" [data]="angularMatData" columnName="ColorVision" dataType="string">
                </filter>
            </mat-header-cell>
            <mat-cell *matCellDef="let row" style="min-width: 140px;">{{row.ColorVision}}</mat-cell>
        </ng-container>
        <ng-container matColumnDef="LPhor">
            <mat-header-cell *matHeaderCellDef mat-sort-header style="min-width: 100px;">L-Phor
                <filter class="mat-filter" [data]="angularMatData" columnName="LPhor" dataType="string">
                </filter>
            </mat-header-cell>
            <mat-cell *matCellDef="let row" style="min-width: 100px;">{{row.LPhor}}</mat-cell>
        </ng-container>
        <ng-container matColumnDef="VPhor">
            <mat-header-cell *matHeaderCellDef mat-sort-header style="min-width: 100px;">V-Phor
                <filter class="mat-filter" [data]="angularMatData" columnName="VPhor" dataType="string">
                </filter>
            </mat-header-cell>
            <mat-cell *matCellDef="let row" style="min-width: 100px;">{{row.VPhor}}</mat-cell>
        </ng-container>
        <ng-container matColumnDef="Hyperopia">
            <mat-header-cell *matHeaderCellDef mat-sort-header style="min-width: 120px;">Hyperopia
                <filter class="mat-filter" [data]="angularMatData" columnName="Hyperopia" dataType="string">
                </filter>
            </mat-header-cell>
            <mat-cell *matCellDef="let row" style="min-width: 120px;">{{row.Hyperopia}}</mat-cell>
        </ng-container>
        <ng-container matColumnDef='Glasses'>
            <mat-header-cell *matHeaderCellDef mat-sort-header style="min-width: 120px;">Glasses
                <filter class="mat-filter" [data]="angularMatData" columnName="Glasses" dataType="boolean"
                    [trueValue]="'true'" [falseValue]="'false'" [showTrueLabel]="'Y'" [showFalseLabel]="''"></filter>
            </mat-header-cell>
            <mat-cell *matCellDef="let row" style="min-width: 120px;">
                <span *ngIf="row.Glasses" style="padding-right: 30px;">Y</span>
            </mat-cell>
        </ng-container>
        <ng-container matColumnDef='UnderDoctorsCare'>
            <mat-header-cell *matHeaderCellDef mat-sort-header style="min-width: 140px;">Under Doctor's Care
                <filter class="mat-filter" [data]="angularMatData" columnName="UnderDoctorsCare" dataType="boolean"
                    [trueValue]="'true'" [falseValue]="'false'" [showTrueLabel]="'Y'" [showFalseLabel]="''"></filter>
            </mat-header-cell>
            <mat-cell *matCellDef="let row" style="min-width: 140px;">
                <span *ngIf="row.UnderDoctorsCare" style="padding-right: 30px;">Y</span>
            </mat-cell>
        </ng-container>
        <ng-container matColumnDef='Referral'>
            <mat-header-cell *matHeaderCellDef mat-sort-header style="min-width: 120px;">Referral
                <filter class="mat-filter" [data]="angularMatData" columnName="Referral" dataType="boolean"
                    [trueValue]="'true'" [falseValue]="'false'" [showTrueLabel]="'Y'" [showFalseLabel]="''"></filter>
            </mat-header-cell>
            <mat-cell *matCellDef="let row" style="min-width: 120px;">
                <span *ngIf="row.Referral" style="padding-right: 30px;">Y</span>
            </mat-cell>
        </ng-container>
        <ng-container matColumnDef='ReferralReturnedToSchool'>
            <mat-header-cell *matHeaderCellDef mat-sort-header style="min-width: 180px;">Referral Returned to School
                <filter class="mat-filter" [data]="angularMatData" columnName="ReferralReturnedToSchool"
                    dataType="boolean" [trueValue]="'true'" [falseValue]="'false'" [showTrueLabel]="'Y'"
                    [showFalseLabel]="''"></filter>
            </mat-header-cell>
            <mat-cell *matCellDef="let row" style="min-width: 180px;">
                <span *ngIf="row.ReferralReturnedToSchool" style="padding-right: 30px;">Y</span>
            </mat-cell>
        </ng-container>
        <ng-container matColumnDef="ReturnDate">
            <mat-header-cell *matHeaderCellDef mat-sort-header style="min-width: 140px;">Return Date
                <filter class="mat-filter" [data]="angularMatData" columnName="ReturnDate" dataType="date"></filter>
            </mat-header-cell>
            <mat-cell *matCellDef="let row" style="min-width: 140px;">
                <span *ngIf="row.ReturnDate != null && row.ReturnDate != '0001-01-01T00:00:00'">
                    {{row.ReturnDate|date:'MM/dd/yyyy'}}
                </span>
            </mat-cell>
        </ng-container>

        <mat-header-row *matHeaderRowDef="columnsToDisplay"></mat-header-row>
        <mat-row *matRowDef="let row; columns: columnsToDisplay;"></mat-row>
    </mat-table>
</div>